function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M15.9931 12.6176L18.8007 15.4253C19.9953 16.6199 19.9953 18.5566 18.8007 19.7512L18.1288 20.4231C17.8302 20.7217 17.346 20.7217 17.0473 20.4231C16.7487 20.1244 16.7487 19.6403 17.0473 19.3416L17.7193 18.6697C18.3165 18.0724 18.3165 17.104 17.7193 16.5068L14.8807 13.6682L1.27355 25.806C0.55486 26.447 -0.44714 25.445 0.193852 24.7263L12.3308 11.1183L9.49306 8.28056C8.89579 7.68329 7.92742 7.68329 7.33015 8.28056L6.65822 8.95249C6.35958 9.25113 5.87539 9.25113 5.57676 8.95249C5.27812 8.65386 5.27812 8.16967 5.57676 7.87104L6.24869 7.19911C7.44323 6.00456 9.37998 6.00456 10.5745 7.19911L13.383 10.0076L19.6495 3.73945C20.0126 4.99649 21.0034 5.98724 22.2604 6.35031L15.9931 12.6176ZM23.3234 5.35294C21.8452 5.35294 20.6469 4.15464 20.6469 2.67647C20.6469 1.1983 21.8452 0 23.3234 0C24.8015 0 25.9998 1.1983 25.9998 2.67647C25.9998 4.15464 24.8015 5.35294 23.3234 5.35294Z",
  fill: "#EFEFEF"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 26,
  height: 26,
  fill: "white"
})));

var SvgPsiIcon = function SvgPsiIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPsiIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/psi-icon.4ab0a7e8.svg";
export { ForwardRef as ReactComponent };